/**
 * Valida a força da senha em tempo real
 * Retorna um objeto com os requisitos e se cada um foi cumprido
 */
export const validatePasswordStrength = (password) => {
  const requirements = [
    {
      id: 'length',
      label: 'Mínimo de 8 caracteres',
      test: (pwd) => pwd.length >= 8,
      met: password.length >= 8
    },
    {
      id: 'lowercase',
      label: 'Pelo menos uma letra minúscula (a-z)',
      test: (pwd) => /[a-z]/.test(pwd),
      met: /[a-z]/.test(password)
    },
    {
      id: 'uppercase',
      label: 'Pelo menos uma letra maiúscula (A-Z)',
      test: (pwd) => /[A-Z]/.test(pwd),
      met: /[A-Z]/.test(password)
    },
    {
      id: 'number',
      label: 'Pelo menos um número (0-9)',
      test: (pwd) => /\d/.test(pwd),
      met: /\d/.test(password)
    },
    {
      id: 'special',
      label: 'Pelo menos um caractere especial (@$!%*?&)',
      test: (pwd) => /[@$!%*?&]/.test(pwd),
      met: /[@$!%*?&]/.test(password)
    }
  ];

  const metCount = requirements.filter(req => req.met).length;
  const allMet = metCount === requirements.length;

  return {
    requirements,
    metCount,
    totalCount: requirements.length,
    allMet,
    isValid: allMet
  };
};

/**
 * Valida se a senha atende a todos os requisitos
 * Retorna true se válida, false caso contrário
 */
export const isPasswordValid = (password) => {
  if (!password || password.length < 8) return false;
  
  const hasLowercase = /[a-z]/.test(password);
  const hasUppercase = /[A-Z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecial = /[@$!%*?&]/.test(password);
  
  return hasLowercase && hasUppercase && hasNumber && hasSpecial;
};

/**
 * Retorna uma mensagem de erro se a senha for inválida
 */
export const getPasswordErrorMessage = (password) => {
  if (!password) return 'Senha é obrigatória';
  if (password.length < 8) return 'Senha deve ter pelo menos 8 caracteres';
  if (!/[a-z]/.test(password)) return 'Senha deve conter pelo menos uma letra minúscula';
  if (!/[A-Z]/.test(password)) return 'Senha deve conter pelo menos uma letra maiúscula';
  if (!/\d/.test(password)) return 'Senha deve conter pelo menos um número';
  if (!/[@$!%*?&]/.test(password)) return 'Senha deve conter pelo menos um caractere especial (@$!%*?&)';
  return null;
};
